import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import {MessageService} from 'primeng/api';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-verify-phonenumber',
  templateUrl: './verify-phonenumber.component.html',
  styleUrls: ['./verify-phonenumber.component.scss']
})
export class VerifyPhonenumberComponent implements OnInit {
  mob_num
  constructor(public auth:AuthService,private messageService: MessageService,public common:CommonService) { }

  ngOnInit(): void {
  }

  sendOTP(phoneverify:NgForm){
    this.mob_num=phoneverify.value.mob_num
    this.common.showLoader()
    this.auth.sendOTP({mob_num:this.mob_num, phone_code:1}).subscribe(res=>{
      //console.log(res)
      this.common.stopLoader()
    },err=>{
      let errorKeys = Object.keys(err.error.errors); 
      errorKeys.forEach(key => { 
        //console.log(key)
        let value = err.error.errors[key][0]; 
        this.messageService.add({severity:'error', summary:value, detail:""});
        //console.log(value); 
    }); 
      //console.log(err)
      this.common.stopLoader()
    })
  }

  verifyOTP(otpverify:NgForm){
    this.common.showLoader()
    this.auth.verifyOTP({otp:otpverify.value.otp,mob_num:this.mob_num, phone_code:1}).subscribe(res=>{
      //console.log(res)
      this.common.stopLoader()
      // this.messageService.add({severity:'success', summary:'Successfull', detail:"otp verified successfully"});
    },err=>{
      let errorKeys = Object.keys(err.error.errors); 
      errorKeys.forEach(key => { 
        //console.log(key)
        let value = err.error.errors[key][0]; 
        this.messageService.add({severity:'error', summary:value, detail:""});
        //console.log(value); 
    }); 
      //console.log(err)
      this.common.stopLoader()
    })
  }

  changeNumber(){
    this.mob_num=null
  }



}
